import { render } from "./MarketId.vue?vue&type=template&id=93cda374&scoped=true&ts=true"
import script from "./MarketId.vue?vue&type=script&lang=ts"
export * from "./MarketId.vue?vue&type=script&lang=ts"

import "./MarketId.vue?vue&type=style&index=0&id=93cda374&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cda374"]])

export default __exports__